module.exports = __webpack_public_path__ + "img/add-folder1.77a8868c.svg";